import React from 'react'
import style from './Loader.module.css'

const loader= ()=>{

  return(
    <div className={style.loader}>Loading...</div>
  )
}
export default loader
